<template>
  <div class="invoice-tabs-bar">
    <div class="invoice-tabs">

      <router-link
        v-if="permission.view_invoice == 1"
        :to="$url('/invoice-history')"
        class="invoice-tab"
        :class="isActive(['Invoices', 'Create Invoice', 'Edit Invoice', 'Re-Create Invoice']) ? 'invoice-tab--active' : ''"
      >
        <font-awesome-icon icon="file-invoice" class="tab-icon" />
        Manage Invoices
      </router-link>

      <router-link
        v-if="permission.view_invoice == 1 || permission.record_invoice_payment == 1"
        :to="$url('/invoice-payment-history')"
        class="invoice-tab"
        :class="isActive(['Invoice Payment History', 'Record Invoice Payment']) ? 'invoice-tab--active' : ''"
      >
        <font-awesome-icon icon="money-bill-wave" class="tab-icon" />
        Manage Payments
      </router-link>

    </div>
  </div>
</template>

<script>
import { computed } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const store      = useStore();
    const router     = useRouter();
    const permission = computed(() => store.state.getCurrentUserPermission);
    const isActive   = (names) => names.includes(router.currentRoute.value.name);
    return { permission, isActive };
  },
};
</script>

<style scoped>
.invoice-tabs-bar {
  background: #fff;
  border-bottom: 1px solid #e4eaf2;
  padding: 0 20px;
  margin-bottom: 20px;
}

.invoice-tabs {
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}
.invoice-tabs::-webkit-scrollbar { display: none; }

.invoice-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 13px 16px;
  font-size: 13.5px;
  font-weight: 500;
  color: #7a90b0;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  margin-bottom: -1px;
  cursor: pointer;
}
.invoice-tab:hover { color: #004AAD; text-decoration: none; }

.invoice-tab--active {
  color: #004AAD !important;
  border-bottom-color: #004AAD !important;
  font-weight: 600;
}

.tab-icon { font-size: 13px; opacity: 0.85; }

@media (max-width: 576px) {
  .invoice-tabs-bar { padding: 0 12px; }
  .invoice-tab      { padding: 11px 12px; font-size: 13px; gap: 5px; }
}
</style>